import { getVesselCallExcelTemplate } from "@services/vesselCallApi";

export const templateDownloadImport = async ({
  templateType,
  fileName,
}: {
  templateType: string;
  fileName: string;
}) => {
  const fileBlob = await getVesselCallExcelTemplate({ templateType });
  const fileUrl = window.URL.createObjectURL(fileBlob);
  const link = document.createElement("a");

  link.href = fileUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(fileUrl);
};
